// extracted by mini-css-extract-plugin
export default {"header":"DashboardView_header__8WqU8","referral":"DashboardView_referral__WlYrk","referralText":"DashboardView_referralText__+hsv3","grid":"DashboardView_grid__IuZ81"};